import { PerspectiveCamera, Vector3 } from "three";
import { useStoreRoom, useStoreSystem } from "../../store";
import { SideType } from "../../store/types/store";
import { SIN_HALF_FOV } from "../../constants";

export const fitCameraToRoom = (
    toTarget: Vector3,
    toCameraPosition: Vector3,
    currentSide: SideType,
    camera: PerspectiveCamera
) => {
    const proMode = useStoreSystem.getState().proMode;
    const roomHeight = useStoreRoom.getState().height / 1000;
    const roomLength = useStoreRoom.getState().length / 1000;
    const roomDepth = proMode ? useStoreRoom.getState().depth / 1000 : useStoreRoom.getState().cameraDistance / 1000;

    const needHeight = currentSide === "top" ? roomDepth : roomHeight;
    const needWidth =
        currentSide !== "top" && (currentSide === "front" || currentSide === "back") ? roomLength : roomDepth;

    const distanceFromWidth = Math.abs((0.5 * needWidth) / camera.aspect / SIN_HALF_FOV); // 0.5 - считаем от половины размера (камера по середине)
    const distanceFromHeight = Math.abs((0.7 * needHeight) / SIN_HALF_FOV); // для высоты считаем чуть больше, чем от половины, чтобы камера была чуть дальше, поэтому 0.7

    const distance = Math.max(distanceFromHeight, distanceFromWidth);

    const direction = toCameraPosition.clone().sub(toTarget).normalize();

    return toTarget.clone().add(direction.clone().multiplyScalar(distance));
};
